<div>

  <!-- Section Header -->
  <div class="mb-6">
    <h1 class="heading-4 text-n900">Notifications</h1>
    <p class="s-body text-n400 mt-1">System alerts and activity updates</p>
  </div>

  <!-- Notification list card -->
  <div class="rounded-2xl bg-white box-shadow-1">

    <div class="divide-y divide-n20">
      <div *ngIf="isLoading && (!rows || rows.length === 0)" class="px-6 pt-4">
        <app-skeleton-card [rows]="5"></app-skeleton-card>
      </div>
      <ng-container *ngIf="rows?.length > 0; else noRecords">
        <div *ngFor="let row of rows"
             class="flex items-start gap-4 px-6 py-4 hover:bg-n10 transition-colors cursor"
             (click)="navigation.navigateByNotification(row)">
          <div class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center" [ngClass]="typeInfo(row.type).tone">
            <i class="ph text-base" [ngClass]="typeInfo(row.type).icon"></i>
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex items-center flex-wrap gap-2 mb-0.5">
              <span class="text-[11px] font-semibold px-2 py-0.5 rounded-full" [ngClass]="typeInfo(row.type).tone">{{ (row.type | notificationType) || 'Notification' }}</span>
              <span class="text-xs text-n400">{{ row.createdDate | appDate }}</span>
            </div>
            <p class="text-sm font-semibold text-n900 mb-0.5 m-0 leading-snug" [innerHTML]="row.title"></p>
            <p class="text-sm text-n400 m-0">{{ row.message }}</p>
          </div>
          <i class="ph ph-arrow-right text-n300 flex-shrink-0 mt-1"></i>
        </div>
      </ng-container>
      <ng-template #noRecords>
        <div class="text-center py-12">
          <img src="assets/images/logo/no-data.svg" alt="No data" class="mx-auto h-28 w-auto mb-3" />
          <p class="text-sm text-n400">No notifications found.</p>
        </div>
      </ng-template>
    </div>

    <div class="px-6 py-4 border-t border-n30">
      <ngb-pagination [collectionSize]="totalPage" [pageSize]="10" [boundaryLinks]="true"
        [(page)]="page" [maxSize]="3" (pageChange)="changePage($event)"></ngb-pagination>
    </div>

  </div>
</div>
